import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const column1 = [
  {
    Header: 'Categories',
    accessor: 'CATEGORY',
    width: 500,
  },

  {
    Header: 'Results',
    accessor: 'RESULTS',
    style: { whiteSpace: 'unset' },
  },
];

const fixMisspelling = data => {
  console.log('Raw supplier caps data:', data);
  console.log('Looking for Business Classification entries...');
  
  // Check if we have any Business Classification entries at all
  const businessClassEntries = data.filter(obj => 
    obj.CATEGORY === 'Business Classification' || 
    obj.CATEGORY === 'Bisiness Classification'
  );
  console.log('Found Business Classification entries:', businessClassEntries);
  
  const fixedData = data
    .map(obj => {
      const newObj = { ...obj };
      if (newObj.CATEGORY === 'Bisiness Classification') {
        newObj.CATEGORY = 'Business Classification';
      }
      if (newObj.CATEGORY === 'Simulation Capability') {
        // Handle simulation capability as boolean
        newObj.RESULTS = newObj.RESULTS === true || newObj.RESULTS === 'true' ? 'Yes' : 'No';
      } else if (newObj.RESULTS === 'true') {
        newObj.RESULTS = 'Yes';
      } else if (newObj.RESULTS === 'false') {
        newObj.RESULTS = 'No';
      }

      return newObj;
    })
    .filter(obj => {
      // Always exclude ICON_Member
      if (obj.CATEGORY === 'ICON_Member') {
        return false;
      }
      
      // Always include Business Classification, even if results are empty
      if (obj.CATEGORY === 'Business Classification' || obj.CATEGORY === 'Bisiness Classification') {
        console.log('Business Classification entry:', obj, 'keeping: true (always show)');
        return true;
      }
      
      // For other categories, exclude if results are empty
      const shouldKeep = obj.RESULTS !== '' && obj.RESULTS !== null && obj.RESULTS !== undefined;
      return shouldKeep;
    });
  
  console.log('Filtered supplier caps data:', fixedData);
  return fixedData;
};

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          <p>Supplier Capabilities</p>
          {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={fixMisspelling(data.block)}
            columns={column1}
            defaultPageSize={
              data.block.length > 0 ? fixMisspelling(data.block).length : 3
            }
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>
      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/CageDetailsTables/SupplierCaps.jsx